// extracted by mini-css-extract-plugin
export default {"panelContainer":"MenuCPanel_panelContainer__dhyQr","perfil":"MenuCPanel_perfil__Oj48a","links":"MenuCPanel_links__OSDX6","homeContainer":"MenuCPanel_homeContainer__Xy6DG"};